import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//COMPONENTS
import YourOrders from "./files/yourOrders/yourOrders";
import YourDetails from "./files/yourDetails";

//STYLES
import * as RouterStyles from "./styles/podRouter";

function PodRouter() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = useState(false);
    const [menuSelected, setMenuSelected] = useState("");

    useEffect(() => {
        setIsLoaded(true);
    });

    function changeNavigationSelection(section) {
        setMenuSelected(section);
        console.log(section);
    }

    function handleMenuClick(section) {
        navigate(`./${section}`);
    }

    return (
        <div>
            <h1 style={RouterStyles.title}>Your Profile</h1>
            <div style={RouterStyles.subNavBar}>
                <Row>
                    <Col sm={2}></Col>
                    <Col>
                        <Row>
                            <Col
                                style={menuSelected == "orders" ? RouterStyles.menuLinkSelected : RouterStyles.menuLink}
                                onClick={handleMenuClick.bind(this, "orders")}
                            >
                                <h2>Your Orders</h2>
                            </Col>
                            <Col
                                style={menuSelected == "details" ? RouterStyles.menuLinkSelected : RouterStyles.menuLink}
                                onClick={handleMenuClick.bind(this, "details")}
                            >
                                <h2>Your Details</h2>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={2}></Col>
                </Row>
            </div>
            <div style={RouterStyles.mainBody}>
                {isLoaded && (
                    <div>
                        <Row>
                            <Col sm={2}></Col>
                            <Col>
                                <Routes>
                                    <Route path={"/orders"} element={<YourOrders navigation={changeNavigationSelection} />} />
                                    <Route path={"/details"} element={<YourDetails navigation={changeNavigationSelection} />} />
                                </Routes>
                            </Col>
                            <Col sm={2}></Col>
                        </Row>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PodRouter;
